import { render } from "./FurnitureGame.vue?vue&type=template&id=b9e204c4&scoped=true"
import script from "./FurnitureGame.vue?vue&type=script&lang=js"
export * from "./FurnitureGame.vue?vue&type=script&lang=js"

import "./FurnitureGame.vue?vue&type=style&index=0&id=b9e204c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9e204c4"

export default script